export default {
  title: 'Aukioloajat ja sijainti',
  set_different_opening_hours: 'Aseta eri aukioloajat toimitukselle',
  delivery_opening_hours: 'Toimituksen aukioloajat',
  sections: {
    general: 'Yleiset aukioloajat',
    holidays: 'Keskeytä tilaukset (lomapäivät)',
    create_time: 'Lisää avausaika',
    edit_time: 'Muokkaa aikaa',
    delivery_schedule: 'Toimituksen aukioloajat',
  },
  tabs: {
    open_times: 'Aukioloajat',
    location: 'Sijainti',
  },
  form: {
    select_all: {
      label: 'Valitse kaikki päivät',
    },
    holiday_starts_at: {
      label: 'Alkamispäivä',
    },
    holiday_ends_at: {
      label: 'Päättymispäivä',
    },
    has_delivery_schedule: {
      label: 'Aseta eri aukioloajat toimitukselle',
    },
    has_multiple_locations: {
      label: 'Aseta eri sijainnit viikolle',
    },
  },
  labels: {
    day_location: '{{day}} sijainti {{index}}',
    selected_days: 'Valitut päivät',
    orders_paused: 'Tilaukset keskeytetty',
    open_time: 'Avausaika',
    close_time: 'Sulkemisaika',
  },
  errors: {
    close_time: 'Sulkemisaika ei voi olla 00:00. Syötä 23:59',
  },
  buttons: {
    edit: 'Muokkaa',
    add_schedule_unit: 'Lisää avausaika',
    add_holiday: 'Lisää lomapäivä',
    delete: 'Poista',
    save: 'Tallenna',
    cancel: 'Peruuta',
  },
  toasts: {
    changes_got_saved: 'Tiedot päivitetty onnistuneesti',
    failed_to_save_changes: 'Muutosten tallennus epäonnistui',
  },
};
